// extracted by mini-css-extract-plugin
module.exports = {"pagination-wrapper":"_11Jvn","paginationWrapper":"_11Jvn"};